import React from 'react';
import { Col, Row, Typography, Space, Button, Divider } from 'antd';
import {
  GlobalOutlined,
  MailOutlined,
  MessageOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';

const { Text, Title } = Typography;

const linkStyle = {
  color: 'rgba(255,255,255,0.8)',
  fontSize: 13,
  transition: 'color 0.2s',
};

const linkHoverProps = {
  onMouseEnter: (e) => { e.currentTarget.style.color = '#ffffff'; },
  onMouseLeave: (e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.8)'; },
};

function PageBottom() {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #1e1f21 0%, #2d1a3e 50%, #1e1f21 100%)',
      padding: '48px 0 0 0',
    }}>
      <Row justify="center">
        <Col xs={22} lg={20} xl={18}>
          <Row gutter={[48, 36]}>
            <Col xs={24} md={6}>
              <img
                src="https://www.bdq.cloud/hubfs/bdq_logo_mono_white.svg"
                height="40"
                alt="BDQ"
                style={{ marginBottom: 16, opacity: 0.9 }}
              />
              <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, display: 'block', lineHeight: 1.6 }}>
                Trusted Asana Solutions Partner serving organisations in the UK, US, and worldwide.
              </Text>
            </Col>

            <Col xs={24} md={6}>
              <Title level={5} style={{ color: '#ffffff', marginBottom: 16, fontSize: 14, letterSpacing: 0.5, textTransform: 'uppercase' }}>
                Services
              </Title>
              <Space direction="vertical" size={8}>
                <Text style={linkStyle}>Asana consultancy</Text>
                <Text style={linkStyle}>Integration & custom apps</Text>
                <Text style={linkStyle}>Training & onboarding</Text>
                <Text style={linkStyle}>Ongoing support</Text>
                <a
                  href="https://www.bdq.cloud/about-us/case-studies"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ ...linkStyle, color: '#9d8abf', marginTop: 4, display: 'inline-block' }}
                  {...linkHoverProps}
                >
                  View case studies <ArrowRightOutlined style={{ fontSize: 11 }} />
                </a>
              </Space>
            </Col>

            <Col xs={24} md={6}>
              <Title level={5} style={{ color: '#ffffff', marginBottom: 16, fontSize: 14, letterSpacing: 0.5, textTransform: 'uppercase' }}>
                Contact
              </Title>
              <Space direction="vertical" size={10}>
                <a href="https://www.bdq.cloud/contact" target="_blank" rel="noopener noreferrer" style={linkStyle} {...linkHoverProps}>
                  <GlobalOutlined style={{ marginRight: 8 }} />www.bdq.cloud
                </a>
                <a href="mailto:enquiries@bdq.cloud" style={linkStyle} {...linkHoverProps}>
                  <MailOutlined style={{ marginRight: 8 }} />enquiries@bdq.cloud
                </a>
                <a
                  href="https://bdq.atlassian.net/servicedesk/customer/portal/29/group/67/create/383"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                  {...linkHoverProps}
                >
                  <MessageOutlined style={{ marginRight: 8 }} />Feature requests
                </a>
              </Space>
            </Col>

            <Col xs={24} md={6}>
              <Title level={5} style={{ color: '#ffffff', marginBottom: 16, fontSize: 14, letterSpacing: 0.5, textTransform: 'uppercase' }}>
                Get Help with Asana
              </Title>
              <Text style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, display: 'block', marginBottom: 16, lineHeight: 1.6 }}>
                Expert consultancy, technical configuration, and integration services.
              </Text>
              <Button
                type="primary"
                href="https://www.bdq.cloud/contact"
                target="_blank"
                rel="noopener noreferrer"
                style={{ borderRadius: 6 }}
              >
                Contact BDQ
              </Button>
            </Col>
          </Row>

          <Divider style={{ borderColor: 'rgba(255,255,255,0.1)', margin: '36px 0 16px 0' }} />

          <Row justify="center" style={{ paddingBottom: 20 }}>
            <Text style={{ color: 'rgba(255,255,255,0.35)', fontSize: 12 }}>
              &copy; 2002–{new Date().getFullYear()} Business Data Quality Ltd. All rights reserved.
            </Text>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default PageBottom;
